<template>
  <div class="plan-add-menu p-2 text-left text-sm mt-8">
    <ul>
      <li v-if="token && favorited.length > 0">
        <a v-on:click="$emit('newPlaceFromFavorite')">
          <div class="w-5">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
              <path d="M11 4.22l-.61-.6c-2.1626-2.045-5.5596-1.9987-7.6656.1046C.6184 5.8278.5677 9.2248 2.61 11.39L11 19.78l8.39-8.4c2.0423-2.1652 1.9916-5.5622-.1144-7.6654-2.106-2.1033-5.503-2.1497-7.6656-.1046l-.61.61z" stroke="#1998c8" stroke-width="1" fill="none" fill-rule="evenodd"/>
            </svg>
          </div>
          <span class="ml-1">{{ $t('tour_add_destination_from_favorite') }}</span>
        </a>
      </li>
      <li>
        <a v-on:click="$emit('newPlaceFromMap')">
          <img src="@/assets/images/icon-menu-map.svg" :alt="$t('tour_map_label')" />
          <span class="ml-1">{{ $t('tour_add_destination_from_map') }}</span>
        </a>
      </li>
      <li>
        <a v-on:click="$emit('newPlace')">
          <img src="@/assets/images/icon-menu-category.svg" :alt="$t('tour_genre_label')" />
          <span class="ml-1">{{ $t('tour_add_destination_category') }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      token: 'user/getToken',
      favorited: 'favorites/getFavoritedPlaces'
    })
  }
}
</script>
